import { render } from "./ReleasePage.vue?vue&type=template&id=334ea164&scoped=true&ts=true"
import script from "./ReleasePage.vue?vue&type=script&lang=ts"
export * from "./ReleasePage.vue?vue&type=script&lang=ts"

import "./ReleasePage.vue?vue&type=style&index=0&id=334ea164&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334ea164"]])

export default __exports__